import React from "react";
import Menu from "../components/Menu/Menu";

const MainPage: React.FC = () => {
  return (
    <>
      <span className="welcome">WELCOME</span>
      <Menu />
    </>
  );
};

export default MainPage;
